export const RECEIVE_APPLIANCES = 'RECEIVE_APPLIANCES';
export const GET_APPLIANCES = 'GET_APPLIANCES';
export const SET_APPLIANCE = 'SET_APPLIANCE';
export const UPDATE_APPLIANCE = 'UPDATE_APPLIANCE';
export const DELETE_APPLIANCE = 'DELETE_APPLIANCE';
export const FETCH_APPLIANCES = 'FETCH_APPLIANCES';
